import { writable } from 'svelte/store'

export const isDrawerOpen = writable(false)
export const drawerComponent = writable('emulate')

export const openDrawer = component => {
  isDrawerOpen.set(true)
  drawerComponent.set(component)
}

export const closeDrawer = () => {
  isDrawerOpen.set(false)
}
